document.addEventListener("DOMContentLoaded", function () {
  // Open sidebar
  document.querySelectorAll(".open-sidebar").forEach((button) => {
    button.addEventListener("click", function () {
      const sidebarId = this.getAttribute("data-sidebar");
      document.body.classList.add("sidebar-active");
      document.querySelectorAll(".sidebar").forEach((sidebar) => {
        if (sidebar.id === sidebarId) {
          sidebar.classList.add("active");
        } else {
          sidebar.classList.remove("active");
        }
      });
    });
  });

  // Close sidebar
  document.querySelectorAll(".close-sidebar").forEach((button) => {
    button.addEventListener("click", function () {
      document.body.classList.remove("sidebar-active");
      document.querySelectorAll(".sidebar").forEach((sidebar) => {
        sidebar.classList.remove("active");
      });
    });
  });
});
